import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import logo from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png";
import ItemDetails from "./ItemDetails";
import Review from "./Review";
import Upload2 from "./Upload2";

export default class CollectionDetails extends Component {
  state = {
    step: 0,
    email: "",
    username: "",
    password: "",
    firstName: "",
    lastName: "",
    country: "",
    levelOfEducation: "",
    collectionTitle: "",
    collectionDescription: "",
    collectionCoverSrc: null,
    collectionCoverFile: "",
    items: [],
    selectedItem: null,
    selectedItemIndex: null,
    sellMethodFixed: false,
    sellMethodBid: false,
  };

  itemsImageBase64 = [];
  tempCounter = 0;

  // go back to previous step
  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  // proceed to the next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  };

  goToStep = (index) => {
    this.setState({ step: index });
  };

  imagePreview = (file, previwer) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = function (event) {
      this.setState({
        [previwer]: reader.result,
      });
    }.bind(this);
  };

  makeItemImageBase64 = (file, iid) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = (event) => {
      let itemIndex = this.state.items.findIndex((item) => item.iid === iid);
      if (itemIndex !== -1) {
        this.itemsImageBase64[itemIndex] = reader.result;
      }
    };
  };

  selectItem = (item, index) => {
    this.setState({ selectedItem: item });
    this.setState({ selectedItemIndex: index });
  };

  removeItems = () => {
    this.setState({ items: [] });
    this.setState({ step: 1 });
    this.itemsImageBase64.length = 0;
  };

  // handle field change
  handleChange = (input) => (e) => {
    switch (input) {
      case "collectionCoverFile":
        if (e.target.files.length === 0) return;
        const coverfile = e.target.files[0];

        this.setState({ [input]: coverfile });
        this.imagePreview(coverfile, e.target.getAttribute("data-preview"));

        break;

      case "itemImage":
        {
          if (e.target.files.length === 0) return;
          const itemImagefiles = e.target.files;
          let { items } = this.state;
          for (let i = 0; i < itemImagefiles.length; i++) {
            if (items.length < 15) {
              this.tempCounter++;
              items.push({
                image: itemImagefiles[i],
                title: "",
                description: "",
                edition: "",
                fixedPrice: "",
                sellMethod: "fixed",
                iid: this.tempCounter,
              });
              this.makeItemImageBase64(itemImagefiles[i], this.tempCounter);
            }
          }

          this.setState({ items: items });
          this.selectItem(items.length > 0 ? items[0] : null, 0);
          e.target.value = "";
          console.log("items", items);
        }

        break;
      case "itemImageDrop":
        {
          if (e.dataTransfer.files.length === 0) return;
          const itemImagefiles = e.dataTransfer.files;
          let { items } = this.state;
          for (let i = 0; i < itemImagefiles.length; i++) {
            if (items.length < 15) {
              this.tempCounter++;
              items.push({
                image: itemImagefiles[i],
                title: "",
                description: "",
                edition: "",
                fixedPrice: "",
                sellMethod: "fixed",
                iid: this.tempCounter,
              });
              this.makeItemImageBase64(itemImagefiles[i], this.tempCounter);
            }
          }

          this.setState({ items: items });
          this.selectItem(items.length > 0 ? items[0] : null, 0);
          e.target.value = "";
          console.log("items", items);
        }

        break;

      case "item-title":
        {
          let { items } = this.state;
          items[this.state.selectedItemIndex].title = e.target.value;
          this.setState({ items: items });
          this.selectItem(
            this.state.items[this.state.selectedItemIndex],
            this.state.selectedItemIndex
          );
        }
        break;
      case "item-description":
        {
          let { items } = this.state;
          items[this.state.selectedItemIndex].description = e.target.value;
          this.setState({ items: items });
          this.selectItem(
            this.state.items[this.state.selectedItemIndex],
            this.state.selectedItemIndex
          );
        }
        break;
      case "item-edition":
        {
          let { items } = this.state;
          items[this.state.selectedItemIndex].edition = e.target.value;
          this.setState({ items: items });
          this.selectItem(
            this.state.items[this.state.selectedItemIndex],
            this.state.selectedItemIndex
          );
        }
        break;
      case "item-fixed-price":
        {
          let { items } = this.state;
          items[this.state.selectedItemIndex].fixedPrice = e.target.value;
          this.setState({ items: items });
          this.selectItem(
            this.state.items[this.state.selectedItemIndex],
            this.state.selectedItemIndex
          );
        }
        break;
      case "sell-method-fixed":
        {
          let { items } = this.state;
          items[this.state.selectedItemIndex].sellMethod = "fixed";
          this.setState({ items: items });
          this.selectItem(
            this.state.items[this.state.selectedItemIndex],
            this.state.selectedItemIndex
          );
        }
        break;
      case "sell-method-bid":
        {
          let { items } = this.state;
          items[this.state.selectedItemIndex].sellMethod = "bid";
          this.setState({ items: items });
          this.selectItem(
            this.state.items[this.state.selectedItemIndex],
            this.state.selectedItemIndex
          );
        }
        break;
      default:
        this.setState({ [input]: e.target.value });
        break;
    }
    console.log(this.state);
  };

  getDataUrl = (img) => {
    // Create canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    // Set width and height
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    // Draw the image
    ctx.drawImage(img, 0, 0);
    return canvas.toDataURL("image/jpeg");
  };

  onSubmitCollection = (event) => {
    event.preventDefault();
    console.log(this.state);
    const formData = new FormData();
    // formData.append("collection-cover-image", this.state.collectionCoverSrc);
    formData.append("collection-cover-image", this.state.collectionCoverFile);
    formData.append("collection-title", this.state.collectionTitle);
    formData.append("collection-description", this.state.collectionDescription);
    formData.append("collection-items", JSON.stringify(this.state.items));
    this.state.items.forEach((item, index) => {
      formData.append("item-" + index, item.image);
    });
    formData.append("sell-method-fixed", this.state.sellMethodFixed);
    formData.append("sell-method-bid", this.state.sellMethodBid);

    axios
      .post(
        "https://nfttest.xyz/nftapi/index.php/home/save_collection",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log(response.data);
        alert(`Collection saved with the id: ${response.data.collection_id}`);
      })
      .catch((error) => {
        // alert(error.response.data.message)
        console.log(error);
      });
  };

  render() {
    const { step } = this.state;
    const {
      email,
      username,
      password,
      firstName,
      lastName,
      country,
      collectionTitle,
      collectionDescription,
      collectionCoverSrc,
      items,
      selectedItem,
      selectedItemIndex,
    } = this.state;
    const values = {
      email,
      username,
      password,
      firstName,
      lastName,
      country,
      collectionTitle,
      collectionDescription,
      collectionCoverSrc,
      items,
      selectedItem,
      selectedItemIndex,
    };

    switch (step) {
      // case 1:
      //     return (
      //         <Upload1
      //             prevStep={this.prevStep}
      //             nextStep={this.nextStep}
      //             handleChange={this.handleChange}
      //             values={this.value}
      //         />
      //     )
      case 1:
        return (
          <Upload2
            prevStep={this.prevStep}
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            values={values}
            removeItems={this.removeItems}
          />
        );
      case 2:
        return (
          <ItemDetails
            prevStep={this.prevStep}
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            values={values}
            selectItem={this.selectItem}
            removeItems={this.removeItems}
          />
        );
      case 3:
        return (
          <Review
            prevStep={this.prevStep}
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            values={values}
            goToStep={this.goToStep}
            submit={this.onSubmitCollection}
          />
        );
      // never forget the default case, otherwise VS code would be mad!
      default:

      // do nothing
    }
    // console.log(this.state)
    return (
      <div className="main-wrapper">
        {/* Header area start */}
        <nav className="navbar navbar-light justify-content-between">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="logo" /> Lorem
          </Link>
          <div className="justify-content-between">
            {/* <Link to="#"><i className="fa fa-search" aria-hidden="true"></i></Link>&emsp;
                        <Link to="/Drops">Drops</Link>&emsp;
                        <Link to="/Marketplace">Marketplace </Link> */}
            <div className="dropdown">
              <button className="dropbtn">
                <i className="fa fa-user" aria-hidden="true"></i>
              </button>
              <div className="dropdown-content text-left">
                <Link to="/AccountInfo">Account Info</Link>
                <Link to="#">Account Activity</Link>
                <Link to="#">Connect Wallet</Link>
                <Link to="/UserProfileBuyer">Buyer Profile</Link>
                <Link to="/CollectionDetails">Add New Collections</Link>
                <Link to="/LoginSignup">Login</Link>
              </div>
            </div>
          </div>
        </nav>
        {/* Header area end */}

        {/* Form area start */}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center form-area">
              <h1 className="text-center">Submit New Collection</h1>

              {/* Progressbar start */}
              <ul id="progress-bar" className="progressbar">
                <li className="active">COLLECTION</li>
                <li>UPLOAD ITEMS</li>
                <li>ITEM DETAILS</li>
                <li>REVIEW & SUBMIT</li>
              </ul>
              {/* Progressbar end */}
            </div>
          </div>
        </div>

        {/* multistep form start*/}
        <div className="container margin-70 arrow">
          <button type="button" disabled>
            &#10229;
          </button>
          <h1>Collection</h1>
          <button type="button" onClick={this.nextStep}>
            &#10230;
          </button>
        </div>
        <div className="container mb-5">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center collection-area">
              <p>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                aliquip ex
              </p>
              <h1>Collection Title</h1>
              <textarea
                type="text"
                rows="1"
                placeholder="Enter Collection Title"
                onChange={this.handleChange("collectionTitle")}
              >
                {collectionTitle}
              </textarea>
              <h1>Description</h1>
              <p>{collectionDescription.length} of 1000 characters used</p>
              <textarea
                maxlength="1000"
                type="text"
                rows="3"
                placeholder="Provide a description of your collection."
                onChange={this.handleChange("collectionDescription")}
              >
                {collectionDescription}
              </textarea>
              <h2>Collection Cover Art</h2>
              <p className="cover-art-detail">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                aliquam erat volutpat. Ut wisi enim ad minim
              </p>
              <br />
              <p className="cover-art-detail">
                (2:1 aspect ratio, 300 dpi recommended)
              </p>
              <div className="card text-center">
                <img src={collectionCoverSrc} className="card-img-top" alt="" />
                <div className="card-body">
                  <input
                    type="file"
                    data-preview="collectionCoverSrc"
                    name="file"
                    onChange={this.handleChange("collectionCoverFile")}
                    className="d-none"
                    id="upload-collection-cover"
                  />
                  <h5>
                    <label for="upload-collection-cover">Upload</label>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* multistep form end*/}
        {/* Form area end */}
      </div>
    );
  }
}
